import React from 'react'
import { graphql } from 'gatsby'
import PageWrap from '../components/Layouts/PageWrap'
import Hero from '../components/Headers/Hero'
// import Offset from '../components/Layouts/Offset'
// import Image from '../components/Images/Image'
import ContactForm from '../components/ContactForm'

const Form = ({ data }) => {
  return (
    <PageWrap seo={data?.page?.seo}>
      <div className="mx-auto pb-20">
        <Hero
          sectionHeader={{ heading: data?.page?.title, as: 'h1' }}
          heading={data?.page?.acf?.header}
          size100
        />
        <div className="container">
          <ContactForm slug={data?.page?.slug || ''} />
        </div>
      </div>
      {/* <Offset rounded={false} allowOverflow={true}>
        <div className="flex pb-20">
          <div className="md:w-1/2 pr-10">
            {data.page.acf?.formIntro && (
              <div
                className="text-gray-600 pt-8 pb-12 text-lg"
                dangerouslySetInnerHTML={{
                  __html: data.page.acf.formIntro,
                }}
              />
            )}
            <ContactForm slug={data?.page?.slug || ''} />
          </div>
          <div className="md:w-1/2">
            <Image
              src={data?.page?.featuredImage?.node?.mediaItemUrl}
              alt={data?.page?.featuredImage?.node?.altText}
              reverse={false}
            />
          </div>
        </div>
      </Offset> */}
    </PageWrap>
  )
}

export default Form

export const query = graphql`
  query($id: String) {
    page: wpPage(id: { eq: $id }) {
      seo {
        ...seoPostTypeFields
      }
      title
      slug
      featuredImage {
        node {
          altText
          mediaItemUrl
        }
      }
    }
  }
`
